import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import './styles.css';

// function MyCustomUploadAdapterPlugin(editor) {
//     editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
//         return new MyUploadAdapter(loader)
//     }
// }

// class MyUploadAdapter {
//     constructor(props) {
//         // CKEditor 5's FileLoader instance.
//         this.loader = props;
//     }

//     // Starts the upload process.
//     upload() {
//         return new Promise((resolve, _) => {
//             resolve({
//                 default: this.loader._reader._data
//             });
//         });
//     }
// }

const editorConfiguration = {
  removePlugins: ['Title'],
  toolbar: {
    items: [
      'heading',
      '|',
      'bold',
      'italic',
      'underline',
      'strikethrough',
      'superscript',
      'subscript',
      '|',
      'highlight',
      'fontBackgroundColor',
      'fontColor',
      'fontFamily',
      'fontSize',
      'alignment',
      '|',
      'todoList',
      'bulletedList',
      'numberedList',
      'outdent',
      'indent',
      '|',
      'link',
      'imageInsert',
      'imageUpload',
      'mediaEmbed',
      'insertTable',
      'blockQuote',
      '|',
      'code',
      'htmlEmbed',
      'codeBlock',
      'horizontalLine',
      'findAndReplace',
      'specialCharacters',
      '|',
      'fullScreen',
      '|',
      'undo',
      'redo',
    ]
  },
  language: 'en',
  image: {
    toolbar: [
      'imageTextAlternative',
      'imageStyle:inline',
      'imageStyle:block',
      'imageStyle:side',
      'linkImage'
    ]
  },
  table: {
    contentToolbar: [
      'tableColumn',
      'tableRow',
      'mergeTableCells',
      'tableCellProperties',
      'tableProperties'
    ]
  },
  heading: {
    options: [
      { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
      { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
      { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
      { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
      { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
      { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
      { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' },
    ]
  },
  link: {
    // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
    addTargetToExternalLinks: true,

    // Let the users control the "download" attribute of each link.
    decorators: {
      toggleDownloadable: {
        mode: 'manual',
        label: 'Downloadable',
        attributes: {
          download: 'file'
        }
      },
      openInNewTab: {
        mode: 'manual',
        label: 'Open in a new tab',
        defaultValue: true,			// This option will be selected by default.
        attributes: {
          target: '_blank',
          rel: 'noopener noreferrer',
        }
      },
      button: {
        mode: 'manual',
        label: 'Button',
        defaultValue: false,			// This option will be selected by default.
        attributes: {
          class: 'button-link'
        }
      },
    }
  }
};

export default function CKEditorCustom(props) {
  const [addedData, setData] = React.useState('');

  const { initData, onChange } = props;

  const handleChange = (event, editor) => {
    const data = editor.getData();
    setData(data);
    // console.log(data);
    // console.log({ event, editor, data });
  }

  useEffect(() => {
    onChange(addedData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addedData])

  let editorEl = null;

  return (
    <div>
      <div>
        <CKEditor
          editor={Editor}
          config={editorConfiguration}
          data={initData}
          onReady={editor => {
            // console.log('Editor is ready to use!', editor);
            // console.log(Array.from(editor.ui.componentFactory.names()));

            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
              editor.ui.view.toolbar.element,
              editor.ui.getEditableElement(),
            );

            // console.log(editor.ui);

            editorEl = editor;
          }}
          onError={({ willEditorRestart }) => {
            // If the editor is restarted, the toolbar element will be created once again.
            // The `onReady` callback will be called again and the new toolbar will be added.
            // This is why you need to remove the older toolbar.
            if (willEditorRestart) {
              editorEl.ui.view.toolbar.element.remove();
            }
          }}
          onChange={handleChange}
          onBlur={(event, editor) => {
            // console.log('Blur.', editor);
          }}
          onFocus={(event, editor) => {
            // console.log('Focus.', editor);
          }}
        />
      </div>
      {/* <div contentEditable='false' dangerouslySetInnerHTML={{ __html: addedData }}></div> */}
    </div>
  )
}

CKEditorCustom.defaultProps = {
  initData: "",
  onChange: (value) => value,
}

CKEditorCustom.propTypes = {
  onChange: PropTypes.func,
  initData: PropTypes.string,
}